import { computed } from '@preact/signals';
import type { TimingTrack } from '@fcbh/audio';
import { frameAt } from '@fcbh/audio';
import { playback } from '../state/store.js';
import { signal } from '@preact/signals';

export const currentTrack = signal<TimingTrack | null>(null);

export const karaoke = computed(() => {
  const track = currentTrack.value;
  if (!track) return null;
  return frameAt(track, playback.value.currentSec);
});
